export default {
  de: {
    designer: 'Designer',
    documenttypes: 'Dokumente',
    postingtypes: 'Postings',
    colors: 'Farbpalette',
    formats: 'Formate',
  },
};
